var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c("h5", { staticStyle: { color: "#C0C4CC" } }, [_vm._v("下单商品")]),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.selectOrderTableData,
                "row-key": "sid",
                "show-header": false,
                "row-style": { color: "red" },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "序号",
                  align: "center",
                  width: "50",
                  type: "index",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "cgoodsSku",
                  align: "center",
                  label: "SKU",
                  width: "90",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "图片", align: "center", width: "70" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.cmasterUrl != null
                          ? _c("el-image", {
                              staticClass: "w30 h30",
                              attrs: {
                                "preview-src-list": [scope.row.cmasterUrl],
                                src: scope.row.cmasterUrl,
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "商品编码",
                  align: "center",
                  width: "130",
                  prop: "cgoodsBarcode",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "商品名称",
                  align: "center",
                  prop: "cgoodsName",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "单位", align: "center", width: "50" },
              }),
              _c("el-table-column", {
                attrs: { label: "单价", align: "center", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            "￥ " +
                              _vm._s((scope.row.dgoodsPrice / 100).toFixed(2))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "数量",
                  prop: "ngoodsNum",
                  align: "center",
                  width: "130",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c("h5", { staticStyle: { color: "#C0C4CC" } }, [_vm._v("替换货品")]),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.replaceTableData,
                "show-header": false,
                "header-cell-style": {
                  background: "#f5f7fa",
                  color: "#606266",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "序号",
                  align: "center",
                  width: "50",
                  type: "index",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "SKU",
                  width: "90",
                  prop: "c_barcode",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "图片", align: "center", width: "70" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.c_master_url != null
                          ? _c("el-image", {
                              staticClass: "w50 h50",
                              attrs: {
                                "preview-src-list": [scope.row.c_master_url],
                                src: scope.row.c_master_url,
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "货品编码",
                  align: "center",
                  width: "130",
                  prop: "c_sku",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "货品名称", align: "center", prop: "c_name" },
              }),
              _c("el-table-column", {
                attrs: { label: "单位", align: "center", width: "50" },
              }),
              _c("el-table-column", {
                attrs: { label: "单价", align: "center", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.n_price
                          ? _c("div", [
                              _vm._v("￥ " + _vm._s(scope.row.n_price)),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "库位",
                  align: "center",
                  width: "70",
                  prop: "c_num",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "数量",
                  align: "center",
                  width: "130",
                  prop: "c_name",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "可用库存", align: "center", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "hHP wHP flex marginLeft10",
                            staticStyle: { "white-space": "break-spaces" },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.formatSurplus(scope.row)) + " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "flex alignItemsCenter marginTop10",
          staticStyle: { "justify-content": "space-between", flex: "1" },
        },
        [
          _c("div"),
          _c(
            "div",
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("关闭"),
              ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }